import { IntlShape, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Typography } from '@rossum/ui/material';
import { boldText } from '../../../../../lib/formaterValues';
import { schemaMapSelector } from '../../../../../redux/modules/schema/schemaMapSelector';
import { UiFieldType } from '../../../../../types/schema';

const resolveExceptionHookName = (
  hookName: string,
  intl: IntlShape,
  valueSource: UiFieldType | undefined
) => {
  return hookName === 'rules'
    ? intl.formatMessage({
        id: 'components.documentValidation.sidebar.exceptionalError.errorMessage.rules',
      })
    : hookName === 'computed_fields' && valueSource
      ? valueSource === 'formula'
        ? intl.formatMessage({
            id: 'components.documentValidation.sidebar.exceptionalError.errorMessage.computedFields.formula',
          })
        : valueSource === 'reasoning'
          ? intl.formatMessage({
              id: 'components.documentValidation.sidebar.exceptionalError.errorMessage.computedFields.reasoning',
            })
          : valueSource === 'lookup'
            ? intl.formatMessage({
                id: 'components.documentValidation.sidebar.exceptionalError.errorMessage.computedFields.lookup',
              })
            : intl.formatMessage({
                id: 'components.documentValidation.sidebar.exceptionalError.errorMessage.computedFields.field',
              })
      : hookName;
};

export const ExceptionMessageTitle = ({
  hookName,
  schemaId,
}: {
  hookName: string;
  schemaId: string | undefined;
}) => {
  const intl = useIntl();

  const schemaMap = useSelector(schemaMapSelector);

  const schema = schemaId ? schemaMap.get(schemaId) : undefined;

  const valueSource =
    !!schema && 'uiConfiguration' in schema
      ? schema.uiConfiguration?.type
      : null;

  const resolvedHookName = resolveExceptionHookName(
    hookName,
    intl,
    valueSource
  );

  return (
    <Typography variant="body2">
      {intl.formatMessage(
        {
          id: 'components.documentValidation.sidebar.exceptionalError.errorMessage',
        },
        { extension: resolvedHookName, boldText }
      )}
    </Typography>
  );
};
